import Box from '@mui/material/Box';
import { Form } from 'react-admin';
import CheckboxToShowBox from '@/components/common/forms/common/checkbox-to-show-box/checkbox-to-show-box';
import TextInputWithLabels from '@/components/common/forms/common/text-input-with-labels/text-input-with-labels';
import ImageInputWithLabelOnTop from '@/components/common/forms/common/image-input-with-label-on-top/image-input-with-label-on-top';

const formId = '_form_maintenance_curative_fissure_1';

interface Props {
    isLoading: boolean;
    onCancel: any;
    onSubmit: any;
    readOnly?: boolean;
    defaultValues?: (formId: string) => {};
}

const CrackForm = ({ readOnly = false, defaultValues = (_formId: string): any => {} }: Props) => (
    <Form defaultValues={defaultValues(formId)}>
        <Box
            sx={{
                display: 'grid',
                gap: 2,
            }}
        >
            <CheckboxToShowBox
                readOnly={readOnly}
                label={"Fissure(s) supérieure(s) à 3mm d'ouverture"}
                keysToRemoveFromFormValues={['Fissure_superieure_3mm_ML', 'Fissure_superieure_3U']}
            >
                <Box
                    sx={{
                        display: 'grid',
                        gap: 1,
                    }}
                >
                    <TextInputWithLabels rightLabel={'ML'} source='Fissure_superieure_3mm_ML' readOnly={readOnly} />

                    <TextInputWithLabels rightLabel={'U'} source='Fissure_superieure_3U' readOnly={readOnly} />
                </Box>
            </CheckboxToShowBox>

            <ImageInputWithLabelOnTop label='Joindre des photos (.png, .jpg)' source='media' readOnly={readOnly} />

            <TextInputWithLabels topLabel={'Précision sur la localisation'} source='Localisation' readOnly={readOnly} />
        </Box>
    </Form>
);

export default CrackForm;
